import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PageWithNavigation } from '../../components';
import PartnerPage from './partners';

const Partners = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <>
      <Helmet>
        <title>Partners</title>
      </Helmet>
      <PageWithNavigation>
        <PartnerPage
          t={t}
          useSelector={useSelector}
          history={history}
          dispatch={dispatch}
          isOffline
        />
      </PageWithNavigation>
    </>
  );
};

export default Partners;
